var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IbBlinkingAnimation',{attrs:{"text":_vm.sentences[_vm.currentSentence]}})
}
var staticRenderFns = []

export { render, staticRenderFns }